import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Lock, ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";
import { useEffect } from "react";

export default function Unauthorized() {
    const navigate = useNavigate();
    const location = useLocation();
    const email = new URLSearchParams(location.search).get("email") || "";

    useEffect(() => {
        // Clear the error param from URL after first read
    }, []);

    return (
        <div className="min-h-screen parchment grain flex items-center justify-center p-6" data-testid="unauthorized-page">
            <div className="max-w-md w-full text-center">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-secondary/10 text-secondary mb-5">
                    <Lock size={26} weight="duotone" />
                </div>
                <div className="text-xs tracking-[0.3em] uppercase text-muted-foreground mb-2">Access denied</div>
                <h1 className="font-serif text-4xl tracking-tight mb-4">You are not authorized</h1>
                <p className="text-foreground/80 leading-relaxed">
                    CounselIQ is currently invite-only. {email && <><span className="font-mono text-sm bg-muted px-1.5 py-0.5 rounded-sm">{email}</span> is</>}{!email && "Your email is"} not on the approved list.
                </p>
                <p className="text-foreground/80 leading-relaxed mt-3 text-sm">
                    Please ask the chambers admin to add you, then sign in again.
                </p>
                <div className="mt-8 flex flex-col gap-2 items-center">
                    <Link to="/" data-testid="back-to-landing-btn">
                        <Button variant="outline" className="rounded-full px-6 gap-2"><ArrowLeft size={14} /> Back to home</Button>
                    </Link>
                    <a href="mailto:" className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1 mt-2">
                        <EnvelopeSimple size={12} /> Need access? Contact your firm's admin.
                    </a>
                </div>
            </div>
        </div>
    );
}
